import { z } from 'zod'

export const AuthorizeWithTwoFactorCodeDTO = z.object({
  code: z.string().min(6).max(12)
})

export type AuthorizeWithTwoFactorCodeDTO = z.infer<typeof AuthorizeWithTwoFactorCodeDTO>

export function mapAuthorizeWithTwoFactorCodeToDTO (code: string): AuthorizeWithTwoFactorCodeDTO {
  return {
    code
  }
}
